import { type StateCreator } from 'zustand';
import { DeviceInUseError } from '../types';
import { getMicPermission } from '../useSessionRecordingStore/lib/getMicPermission';
import { type AudioGraphStore } from './types';

export interface MicSlice {
  testMic: () => Promise<void>;
}

export const createMicSlice: StateCreator<AudioGraphStore, [], [], MicSlice> = (
  _,
  get
) => ({
  testMic: async () => {
    const { addError, clearError } = get();

    let micCheck: Awaited<ReturnType<typeof getMicPermission>>;
    try {
      micCheck = await getMicPermission();
    } catch (err) {
      // An acquisition failure is not a permission denial — recording it as
      // MIC_DISALLOWED would surface "grant mic access" copy even though the
      // browser may have failed because of contention or a device issue.
      if (err instanceof DeviceInUseError) {
        addError('DEVICE_IN_USE');
        // A busy-device rejection also proves permission was granted; a
        // stale MIC_DISALLOWED would otherwise outrank the fresh code in
        // mini-mode's precedence order.
        clearError('MIC_DISALLOWED');
      } else {
        addError('MIC_DISALLOWED');
      }
      throw err;
    }

    clearError('MIC_DISALLOWED');
    // Only a real stream acquisition proves the device is free — the
    // query-granted fast path never touches the device, so clearing there
    // would hide a genuinely busy mic.
    if (micCheck === 'stream-verified') {
      clearError('DEVICE_IN_USE');
    }
  },
});
